import { BaseComponent } from '../../components/base-component'
import { fetchConfig } from '../../utils/fetch-config'
import { CartAPI } from '../../api/cart-api'
import { $el, $elParent } from '../../utils/utils'
import { debounce } from '../../utils/debounce'
import { BottomSheet } from 'src/scripts/components/bottom-sheet'

const SELECTOR_APPLY_BUTTON = '.cart-note__apply-button'
const SELECTOR_TEXTAREA = '.cart-note__textarea'
const SELECTOR_BOTTOM_SHEET = '.bottom-sheet'

export const EVENT_CART_NOTE_APPLY_BUTTON_CLICK = 'cartNoteBeforeApply'
export const EVENT_CART_NOTE_APPLY = 'cartNoteApply'
export const EVENT_CART_NOTE_ERROR_APPLY = 'cartNoteErrorApply'

export class CartNote extends BaseComponent {
  cartAPI = new CartAPI()
  textarea: HTMLTextAreaElement
  applyButton: HTMLElement
  initialValue: string

  mountComponent(): void {
    super.mountComponent()

    this.textarea = $el(SELECTOR_TEXTAREA, this)
    this.applyButton = $el(SELECTOR_APPLY_BUTTON, this)
    this.initialValue = this.getTextareaValue()

    this.addListener(this.applyButton, 'click', this.handleApplyButtonClick)
    this.addListener(this.textarea, 'blur', this.handleTextareaBlur)
  }

  unmountComponent(): void {
    super.unmountComponent()

    this.removeListener(this.applyButton, 'click', this.handleApplyButtonClick)
    this.removeListener(this.textarea, 'blur', this.handleTextareaBlur)
  }

  handleTextareaBlur = () => this.saveCartNote()

  handleApplyButtonClick = () => {
    $elParent<BottomSheet>(SELECTOR_BOTTOM_SHEET, this)?.hide()
    this.saveCartNote()
  }

  getTextareaValue = () => this.textarea.value

  saveCartNote = debounce(async () => {
    if (this.initialValue === this.getTextareaValue()) {
      return
    }

    try {
      await this.cartAPI.update({
        ...fetchConfig(),
        body: JSON.stringify({
          note: this.getTextareaValue(),
        }),
      })

      this.initialValue = this.getTextareaValue()
    } catch (e) {
      console.error(e)
    }
  }, 500)
}
